import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function NewsPaperReport() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">

        {/*
        <Box my={8}>
          <Grid className="p-3" spacing={0} container direction="row" justify="center">
            <Grid item xs={12} md={4} className="p-3">
              <a href="/pdf/wanted/newspaperreport.pdf">
                <img src="/images/wanted/newspaperreport.jpg" className="img-fluid" />
              </a>
            </Grid>
            <Grid item xs={12} md={7} className="p-3">
              <Typography className="font-weight-bold my-3" variant="h5" component="h2">
                第１２回新聞感想文コンクール
              </Typography>
              　デーリー東北新聞社は、子どもの頃から新聞に親しみ、読解力や表現力を高めることを目的に、第１２回「デーリー東北　新聞感想文コンクール」を実施します。令和３年６月以降のデーリー東北に掲載された記事を読んでの感想を、小学生から高校生までの計４部門で募集します。<br/>
              <div class="fs90 text-left m-3">
                主　催：デーリー東北新聞社<br/>
                協　賛：デーリー東北販売店会<br/>
                後　援：青森県教育委員会、岩手県教育委員会<br/>
              </div>
            </Grid>
          </Grid>
        </Box>
        */}
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            第１３回新聞感想文コンクール
          </Typography>
          {/* <Typography className="text-danger font-weight-bold my-3" variant="body1" component="h2">
            作品の募集は終了しました。
          </Typography> */}
          　デーリー東北新聞社は、子どもの頃から新聞に親しみ、読解力や表現力を高めることを目的に、第１３回「デーリー東北　新聞感想文コンクール」を実施します。２０２２年４月以降のデーリー東北に掲載された記事を読んでの感想を、小学生から高校生までの計４部門で募集します。<br/>
          <div class="fs90 text-left m-3">
            主　催：デーリー東北新聞社<br/>
            協　賛：デーリー東北販売店会<br/>
            後　援：青森県教育委員会、岩手県教育委員会<br/>
          </div>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            第１３回「デーリー東北新聞感想文コンクール」実施要項
          </Typography>
          <dl>
            <dt>事業名</dt>
            <dd>
              第１３回デーリー東北新聞感想文コンクール
            </dd>
            <dt>主　催</dt>
            <dd>
              デーリー東北新聞社
            </dd>
            <dt>協　賛</dt>
            <dd>
              デーリー東北販売店会
            </dd>
            <dt>後　援</dt>
            <dd>
              青森県教育委員会<br/>
              岩手県教育委員会
            </dd>
            <dt>応募対象</dt>
            <dd>
              青森県、岩手県内の小学校、中学校、高校に在学する児童、生徒
            </dd>
            <dt>応募課題</dt>
            <dd>
              ２０２２年４月以降のデーリー東北に掲載された記事を読んで感じたこと、気づいたことなどを自由に書いてください。
              <div class="fs90 text-danger">
                ※デーリー東北以外は選外です。<br/>
              </div>
            </dd>
            <dt>部　門</dt>
            <dd>
              ① 小学３・４年生の部<br/>
              ② 小学５・６年生の部<br/>
              ③ 中学生の部<br/>
              ④ 高校生の部<br/>
            </dd>
            <dt>応募方法</dt>
            <dd>
              （１）学校単位、個人でも受け付けます。学校単位での申し込みの場合は、責任者名、電話番号を明記し、応募作品が多数の場合は一覧表（別紙）を添付してください。<br/>
              （２）４００字詰め原稿用紙に小学生は２枚以内。中学生、高校生は３枚以内。<br/>
              （３）原稿用紙の１行目に「タイトル」、２行目に「学校名と学年」、３行目に「氏名（ふりがな）」、４行目は空白、５行目から本文を書き始めてください。別の原稿用紙に読んだ記事（コピー可）を貼り付け、掲載日（年月日）を記入。郵便番号、住所、電話番号、保護者名も書いて郵送または持参してください。規定が守られていない場合、審査前の段階で不採用とします。<br/>
            </dd>
            <dt>応募期間</dt>
            <dd>
              ２０２２年６月１日（水）～９月９日（金）
            </dd>
            <dt>応募先</dt>
            <dd>
              〒０３１－８６０１（住所の記載は不要です）<br/>
              デーリー東北新聞社「新聞感想文コンクール」係
            </dd>
            <dt>表　彰</dt>
            <dd>
            各部門とも最優秀賞１編、優秀賞２編、入選５編<br/>
              ＊最優秀賞・・・表彰状、図書カード<br/>
              ＊優 秀 賞・・・表彰状、図書カード<br/>
              ＊入　　選・・・表彰状、図書カード<br/>
              ＊優秀学校賞（小学校１､中学校１､高校１）・・・表彰状、図書カード<br/>
              ＊参 加 賞・・・応募者全員<br/>
            </dd>
            <dt>結果発表</dt>
            <dd>
              ２０２２年１１月上旬にデーリー東北紙上で各部門の最優秀賞、優秀賞の作品と入選者全員の氏名と学校名、応募学校名を掲載
            </dd>
            <dt>表彰式</dt>
            <dd>
              ２０２２年１１月　デーリー東北新聞社本社
            </dd>
            <dt>問い合わせ</dt>
            <dd>
              デーリー東北新聞社「新聞感想文コンクール」係<br/>
              電話０１７８－８０－７０８２<br/>
              （土・日・祝日を除く９：３０～１７：００）<br/>
              <div class="fs90 text-danger line150 text-left m-3">
                ※応募作品は返却しません。応募者の個人情報は、本事業のみに使用します。<br/>
                ※新型コロナウイルスの影響で日程が変更になる可能性もございます。<br/>
              </div>
            </dd>
          </dl>
        </Box>
      </div>
    </div>
  );
}

export default NewsPaperReport;
